module.exports = __webpack_public_path__ + "static/daily_activity-36f7057fc9378d5dd4c1caa4a9ad3925.png";